import React from "react";
import { message, Modal, Table, Tooltip, Input } from "antd";
import { GeneratorList } from "../../../../models/generator";
import { EditGeneratorData } from "./popups/EditGeneratorData"
import { pagination } from "../../../../controller/Utils";

const Search = Input.Search

export class GeneratorDataManage extends React.Component {
  state = {
    modelGenerator: false,
    params: {},
    data: [],
    popupDataList: [],
    selectedRowKeys: [],
    pagination: pagination
  };
  onRowShowClick = (ids) => {
    this.setModelGenerator(true);
    GeneratorList({ ids: ids })
      .then(response => {
        this.setState({ popupDataList: response.data.results })
      });
  };
  onRowUpdateClick = (row_id) => {
    this.setEditGenerator(true);
    this.setState({ row_id })
  };
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      ...filters,
    });
  };
  fetch = (params = {}) => {
    params =  {...this.state.params, ...params};
    this.setState({ loading: true, params: params });
    GeneratorList(params)
      .then(response => {
        const pagination = { ...this.state.pagination };
        pagination.total = response.data.count;
        this.setState({
          loading: false,
          data: response.data.results,
          pagination,
        });
      });
  };
  columns = [
    {
      title: 'Action',
      render: item => <div className="action-column">
        <a title="View" onClick={() => this.onRowShowClick([item.id])}><i className="fa fa-eye" /></a>
        <a title="Edit" onClick={() => this.onRowUpdateClick(item.id)}><i className="fa fa-pencil" /></a>
      </div>
    },
    {
      title: 'Account Number',
      dataIndex: 'account_number',
    }, {
      title: 'Company Name',
      dataIndex: 'company_name',
    }, {
      title: 'City',
      dataIndex: 'city',
    }, {
      title: 'State',
      dataIndex: 'state',
    }, {
      title: 'Zip Code',
      dataIndex: 'zip_code',
    }, {
      title: 'Phone',
      dataIndex: 'phone',
    }, {
      title: 'Contact',
      dataIndex: 'contact',
    }
  ];
  onMultipleRowShowClick = () => {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length)
      this.onRowShowClick(selectedRowKeys);
    else
      message.info('Please select any one row for show');
  };
  onCheckboxSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  setModelGenerator(modelGenerator) {
    this.setState({ modelGenerator });
  }

  setEditGenerator(modelEditGenerator) {
    this.setState({ modelEditGenerator });
    if (!modelEditGenerator)
      this.setState({ row_id: modelEditGenerator })
  }

  componentDidMount() {
    this.fetch();
  }

  render() {
    const { selectedRowKeys, pagination, loading } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onCheckboxSelectChange,
    };
    const { popupDataList } = this.state;

    return (
      <React.Fragment>
        <div className="col-sm-3 col-xs-12">
          <button className="btn submit-btn xs-hide" type="button"
            onClick={item => this.onRowUpdateClick(item.id)}>Create Generator
          </button>
          <button className="btn submit-btn xs-show" type="button" onClick={item => this.onRowUpdateClick(item.id)}><i
            className="fa fa-plus" />
          </button>
        </div>
        <div className="col-sm-3 col-10 pull-xs-right">
          <Search placeholder="Input search text" onSearch={value => this.fetch({ search: value })} />
        </div>
        <div className="col-sm-3 col-12 edit-div">
          <span>{pagination.total} Records</span>
          <button className="btn btn-edit">
            <i className="icon-printer" />
          </button>
          <button type="primary" className="btn btn-edit" onClick={this.onMultipleRowShowClick}>
            <i className="fa fa-eye" />
          </button>
        </div>
        <div className="col-12 date-row">
          <p>Generators Data</p>
        </div>
        <div className="col-12">
          <div className="listing-table data-manage-tbl">
            <Table rowSelection={rowSelection} onChange={this.handleTableChange} pagination={pagination}
              columns={this.columns} dataSource={this.state.data} rowKey={row => row.id} loading={loading}
              className="responsive-table table table-hover js-basic-example dataTable table-custom table-striped m-b-0 c_list" />
          </div>
        </div>
        <EditGeneratorData fetch={() => this.fetch()} row_id={this.state.row_id} visible={this.state.modelEditGenerator} setModelVisible={() => this.setEditGenerator(false)} />

        <Modal title="View Details" centered visible={this.state.modelGenerator}
          onOk={() => this.setModelGenerator(false)} onCancel={() => this.setModelGenerator(false)} width={'75%'}
          className={"view-data-modal"}>
          {popupDataList.map((item, index) => {
            return (
              <div key={index} className="row single-data-row data-manage">
                <div className="col-12 header-view-data">
                  <div className="view-data-div">
                    <span>Company Name</span>
                  </div>
                  <div className="view-data-div">
                    <span>Email</span>
                  </div>
                  <div className="view-data-div">
                    <span>Address</span>
                  </div>
                  <div className="view-data-div">
                    <span>City</span>
                  </div>
                  <div className="view-data-div">
                    <span>State</span>
                  </div>
                  <div className="view-data-div num-div">
                    <span>Zip Code</span>
                  </div>
                  <div className="view-data-div">
                    <span>Phone</span>
                  </div>
                  <div className="view-data-div">
                    <span>Contact</span>
                  </div>
                  <div className="view-data-div">
                    <span>Business Category</span>
                  </div>
                </div>
                <div className="view-data-row">
                  <div className="col-12 quote-details">
                    <div className="view-data-div">
                      <span>{item.company_name}</span>
                    </div>
                    <div className="view-data-div">
                      <span>{item.email}</span>
                    </div>
                    <div className="view-data-div">
                      <Tooltip placement="bottom" title={item.address}>
                        <span>{item.address}</span>
                      </Tooltip>
                    </div>
                    <div className="view-data-div">
                      <span>{item.city}</span>
                    </div>
                    <div className="view-data-div">
                      <span>{item.state}</span>
                    </div>
                    <div className="view-data-div num-div">
                      <span>{item.zip_code}</span>
                    </div>
                    <div className="view-data-div">
                      <span>{item.phone}</span>
                    </div>
                    <div className="view-data-div">
                      <span>{item.contact}</span>
                    </div>
                    <div className="view-data-div">
                      <span>{item.business_category.name}</span>
                    </div>
                  </div>
                </div>
                <div className="view-data-row">
                  <div className="col-12 quote-details view-bottom-div">
                    <div className="view-data-div">
                      <span>Notes:</span>
                      <p>{item.notes}</p>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </Modal>
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/tracks/data_management/generator_data/GeneratorDataManage.jsx